  (function () {
    if (window.baumontOpenAIPixelInstalled) return;
    window.baumontOpenAIPixelInstalled = true;

    const pixelId = "9Y942Me6wp5ZBEYFEEECxi";
    const productId = document.currentScript.dataset.productId || null;
    let initialized = false;
    let marketingAllowed = false;
    let pageMeasured = false;

    function measure(eventName, contents) {
      if (!marketingAllowed || !initialized) return;
      const data = { type: "contents" };
      if (contents && contents.length) data.contents = contents;

      try {
        window.oaiq("measure", eventName, data);
      } catch (error) {
        // Uma falha de medição não deve interromper a vitrine.
      }
    }

    function syncConsent() {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== "function") return;

      const allowed = privacy.marketingAllowed();
      if (initialized && allowed === marketingAllowed) return;
      marketingAllowed = allowed;

      if (!initialized && !allowed) return;

      if (!initialized && !window.oaiq) {
        const queue = function () { queue.q.push(arguments); };
        queue.q = [];
        window.oaiq = queue;

        const sdk = document.createElement("script");
        sdk.async = true;
        sdk.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
        document.head.appendChild(sdk);
      }

      window.oaiq("consent", allowed);
      if (!initialized) {
        window.oaiq("init", { pixelId });
        initialized = true;
      }

      if (allowed && !pageMeasured) {
        pageMeasured = true;
        measure("page_viewed");
        if (productId) {
          measure("contents_viewed", [{ id: productId, content_type: "product" }]);
        }
      }
    }

    function isCartAdd(method, address) {
      if (String(method).toUpperCase() !== "POST" || !address) return false;

      try {
        const url = new URL(address, window.location.href);
        return url.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
      } catch (error) {
        return false;
      }
    }

    function reportCartAdd(response) {
      if (!response || Number(response.status) >= 400) return;

      const items = Array.isArray(response.items) ? response.items : [response];
      const ids = new Set(items.map(item => item && item.product_id).filter(Boolean));
      const contents = Array.from(ids, id => ({ id: String(id), content_type: "product" }));

      if (contents.length) measure("items_added", contents);
    }

    // Os botões do tema enviam a adição via fetch.
    const originalFetch = window.fetch;
    window.fetch = function (request, options) {
      const address = typeof request === "string" || request instanceof URL ? request : request && request.url;
      const method = (options && options.method) || (request && request.method);
      const result = originalFetch.apply(this, arguments);

      if (marketingAllowed && isCartAdd(method, address)) {
        result.then(response => {
          if (response.ok && marketingAllowed) {
            return response.clone().json().then(reportCartAdd);
          }
        }).catch(() => {});
      }

      return result;
    };

    // O botão que prepara o checkout da Yever também adiciona pela Shopify, via XHR.
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, address) {
      const result = originalOpen.apply(this, arguments);

      if (marketingAllowed && isCartAdd(method, address)) {
        const request = this;
        function onComplete() {
          if (request.readyState !== 4) return;
          request.removeEventListener("readystatechange", onComplete);

          if (!marketingAllowed || request.status < 200 || request.status >= 300) return;
          try {
            const data = request.responseType === "json" ? request.response : JSON.parse(request.responseText);
            reportCartAdd(data);
          } catch (error) {
            // Resposta sem JSON utilizável para medição.
          }
        }

        request.addEventListener("readystatechange", onComplete);
      }

      return result;
    };

    function loadPrivacy() {
      const shopify = window.Shopify;
      if (!shopify) return;
      if (shopify.customerPrivacy && typeof shopify.customerPrivacy.marketingAllowed === "function") {
        syncConsent();
      } else if (typeof shopify.loadFeatures === "function") {
        shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.2" }], error => {
          if (!error) syncConsent();
        });
      }
    }

    document.addEventListener("visitorConsentCollected", syncConsent);
    if (window.Shopify) {
      loadPrivacy();
    } else {
      document.addEventListener("DOMContentLoaded", loadPrivacy, { once: true });
    }
  })();
